<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-4">
        <img :src="warning" class="img-fluid">
      </div>
      <div class="col-lg-4">
        <h5>¡Vaya…!</h5>
        <p>No pudimos encontrar la Guia ingresada</p>
      </div>
    </div>
  </div>
</template>
<script>
import warning from '@/assets/icons/warning.svg'
export default {
  data () {
    return {
      warning
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/noResult.vue